<template>
  <div class="list">
    <div class="title">
      <span>{{ title }}</span>
    </div>
    <div v-if="title === 'Webhook'">
      <router-link
          :to="{
          name: 'detail',
          params: {
            id: 'Webhook',
            pilot: 'ユーザー',
          },
          hash: '#Webhook-Limitations',
        }"
          style="color: #4c4c4c; text-decoration: none"
      >
        <div class="contents" style="padding: 7px 0px 5px 17px">
          Webhookの制限事項
        </div>
      </router-link>
      <router-link
          :to="{
          name: 'detail',
          params: {
            id: 'Webhook',
            pilot: 'ユーザー',
          },
          hash: '#Webhook-Payload',
        }"
          style="color: #4c4c4c; text-decoration: none"
      >
        <div class="contents" style="padding: 7px 0px 5px 17px">
          Webhookのペイロード
        </div>
      </router-link>
      <router-link
          :to="{
          name: 'detail',
          params: {
            id: 'Webhook',
            pilot: 'ユーザー',
          },
          hash: '#Webhook-Event-Triggers',
        }"
          style="color: #4c4c4c; text-decoration: none"
      >
        <div class="contents" style="padding: 7px 0px 5px 17px">
          Webhookのイベントトリガー
        </div>
      </router-link>
    </div>
    <div class="contents">
      <div class="content__left">対象</div>
      <div class="content__right">{{ pilot }}</div>
    </div>
    <div class="contents">
      <div class="content__left">方式</div>
      <div class="content__right">機能</div>
    </div>
    <template v-for="data of parsed">
      <div class="data contents" v-for="ref of data.methods">
        <router-link
            :to="{
            name: 'detail',
            params: {
              pilot: pilot,
              id: data.refValue[ref].tags[0],
            },
            hash: '#' + data.refValue[ref].summary,
          }"
            style="color: #4c4c4c; text-decoration: none"
        >
          <div
              class="content__left"
              v-if="ref === 'get'"
              style="color: #1c4dac; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div
              class="content__left"
              v-if="ref === 'post'"
              style="color: #2e8540; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div
              class="content__left"
              v-if="ref === 'put'"
              style="color: #95507c; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div
              class="content__left"
              v-if="ref === 'delete'"
              style="color: #cc3333; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div class="content__right content__summary">
            {{ data.refValue[ref].summary }}
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'HomeList',
  props: {
    title: String,
    parsed: Array,
    pilot: String,
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 10000px) {
  /*가로 너비가 600px 이하일 때 아래 스타일 적용*/
  .list {
    display: inline-block;
    box-sizing: inherit;
    color: #545b64;
    width: 100%;
    border: 1px solid #d5dbdb;
  }

  a:hover {
    color: #0073bb;
    text-decoration-color: #0073bb;
    text-decoration: underline;
  }

  .title {
    background-color: #f8f8f9;
    line-height: 1.8;
    vertical-align: middle;
    color: #545b64;
    font-size: 1.65em;
    font-weight: 700;
    text-align: left;
    padding: 7px 0px 5px 17px;
    font-family: arial, sans-serif;
  }

  .contents {
    border-top: 1px solid #d5dbdb;
    color: #16191f;
    padding: 10px 0px 10px 3px;

    .content__left {
      display: inline-block;
      width: 12%;
      text-align: left;
      font-size: 1.2em;
      line-height: 1.6;
      padding-left: 13px;
      color: #002947;
    }

    .content__right {
      display: inline-block;
      text-align: right;
      font-size: 1.2em;
      line-height: 1.6;
      color: #002947;
    }

    .content__summary:hover {
      text-decoration: underline;
    }
  }
}
</style>
